export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11565.fb96c86f.jpg";